module.exports = __webpack_public_path__ + "static/media/BG-test.bc1e0654.PNG";